import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ResponseToastService, ToastState } from '../../services/response-toast.service';

@Component({
  selector: 'app-response-toast',
  templateUrl: './response-toast.component.html',
  styleUrls: ['./response-toast.component.scss'],
})
export class ResponseToastComponent implements OnInit, OnDestroy {
  toast: ToastState | null = null;
  private sub: Subscription | null = null;

  constructor(private toastService: ResponseToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.toast$.subscribe(t => (this.toast = t));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
